var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"groupnews_insideL"},[_c('iframe',{staticStyle:{"margin-top":"-100px"},attrs:{"id":"iframe","src":_vm.link,"height":_vm.iframeheight,"width":"100%","frameborder":"0","scrolling":"no"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-467e1bb2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/solutions/components/solutions1.vue
// module id = null
// module chunks = 